import { colorPalette } from '@next-common/mui';
export const deskAvatarSize = '71px';
export const mobAvatarSize = '50px';
export const mobIconSize = '20px';
export const deskIconSize = '35px';
export const content = {
    width: { xs: mobAvatarSize, sm: deskAvatarSize },
    height: { xs: mobAvatarSize, sm: deskAvatarSize },
    maxWidth: { sm: deskAvatarSize },
    maxHeight: { sm: deskAvatarSize },
};
export const combination = Object.assign({}, content);
export const errorCombination = Object.assign(Object.assign({}, content), { backgroundColor: `${colorPalette.gray100}`, color: `${colorPalette.gray700}` });
export const iconClass = (theme) => ({
    fontSize: mobIconSize,
    [theme.breakpoints.up('sm')]: {
        fontSize: deskIconSize,
    },
});
